import { createRootRoute } from '@tanstack/react-router';
import { PendoGuideManager } from 'common/components/pendo/PendoGuideManager';
import ExitPrompt from 'common/components/exitPrompt';
import MainPanel from 'features/mainPanel';

export const Route = createRootRoute({
  component: () => (
    <>
      {/* <TanStackRouterDevtools /> */}
      <PendoGuideManager />
      <ExitPrompt>
        <MainPanel />
      </ExitPrompt>
    </>
  ),
});
